import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CampaignDisplayChannel } from '@core/models/campaign-display/campaign-display.model';

@Component({
standalone: false,
  selector: 'app-region-dialog',
  templateUrl: './region-dialog.component.html',
  styleUrls: ['./region-dialog.component.scss'],
})
export class RegionDialogComponent implements OnInit {
  @Input() channels: CampaignDisplayChannel[];

  constructor(
    @Optional() public dialogRef: MatDialogRef<RegionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CampaignDisplayChannel[]
  ) {}

  ngOnInit(): void {
    // Here we can initialize the component with the data passed to the dialog
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
